import React from 'react'
import PropTypes from 'prop-types'

const Image = ({item, hideDetails}) => {
  return (
    <div className={"order-card-image-container"}>
        <img
            src={item.reward_image}
            className={`hidden order-card-image ${(item.reward_hide && hideDetails) && "blur"}`}
            alt={item.reward_title}
          />
      </div>
  )
};

Image.propTypes = {
    item: PropTypes.object,
    hideDetails: PropTypes.bool,
};

export default Image;